module.exports = __webpack_public_path__ + "static/media/express.ac71b350.svg";